import { withProps } from 'recompose'
import { domains } from '../constants'

const withCharityDomain = withProps(props => ({ domain: domains.CHARITIES }))

export default withCharityDomain



// WEBPACK FOOTER //
// ./src/services/charity/withCharityDomain.js